import React from 'react'
import Icon from 'components/Icon'
import cx from 'classnames'
import styles from './ReportedStatus.scss'
import Tooltip from 'components/Tooltip'

type StatusIconMap = Record<reportedStatusValue, string>

export type reportedStatusValue =
  | 'nonFilerRed'
  | 'nonFilerOrange'
  | 'underReportedYellow'
  | 'underReportedOrange'
  | 'underReportedRed'
  | 'zeroReportedRed'
  | 'zeroReportedOrange'
  | 'properReport'
  | 'noActivity'
  | 'noFile'
  | 'underReport'
  | 'noReport'
  | 'waitingForReport'
  | 'processing'
  | 'abroadIncomeForeignCompanyReport'
  | 'abroadIncomeForeignCompanyNoReport'
  | 'abroadIncomeFalseForeignCompanyReport'
  | 'abroadIncomeFalseForeignCompanyNoReport'
  | 'foreignRegionReport'
  | 'noFile_oleHadash'
  | 'noReport_oleHadash'
  | 'underReport_oleHadash'
  | 'properReport_oleHadash'
  | 'waitingForReport_oleHadash'
  | 'noFile_oldReturningResident'
  | 'noReport_oldReturningResident'
  | 'underReport_oldReturningResident'
  | 'properReport_oldReturningResident'
  | 'waitingForReport_oldReturningResident'
  | 'noFile_returningResident'
  | 'noReport_returningResident'
  | 'underReport_returningResident'
  | 'properReport_returningResident'
  | 'waitingForReport_returningResident'
  | 'noFile_disabled'
  | 'noReport_disabled'
  | 'underReport_disabled'
  | 'properReport_disabled'
  | 'waitingForReport_disabled'
  | 'noFile_oleHadash_disabled'
  | 'noReport_oleHadash_disabled'
  | 'underReport_oleHadash_disabled'
  | 'properReport_oleHadash_disabled'
  | 'waitingForReport_oleHadash_disabled'
  | 'noFile_oldReturningResident_disabled'
  | 'noReport_oldReturningResident_disabled'
  | 'underReport_oldReturningResident_disabled'
  | 'properReport_oldReturningResident_disabled'
  | 'waitingForReport_oldReturningResident_disabled'
  | 'noFile_returningResident_disabled'
  | 'noReport_returningResident_disabled'
  | 'underReport_returningResident_disabled'
  | 'properReport_returningResident_disabled'
  | 'waitingForReport_returningResident_disabled'

export const statusIconMap: StatusIconMap = {
  nonFilerRed: 'nonFilerV2Red',
  nonFilerOrange: 'nonFilerV2Orange',
  underReportedYellow: 'underReportedV2Yellow',
  underReportedOrange: 'underReportedV2Orange',
  underReportedRed: 'underReportedV2Red',
  zeroReportedRed: 'zeroReportedV2Red',
  zeroReportedOrange: 'zeroReportedV2Orange',
  properReport: 'properReport',
  waitingForReport: 'waitingForReport',
  processing: 'processing',
  noActivity: 'noActivity',
  noFile: 'noFile',
  underReport: 'underReport',
  noReport: 'noReport',
  abroadIncomeForeignCompanyReport: 'abroadIncomeForeignCompanyReport',
  abroadIncomeForeignCompanyNoReport: 'abroadIncomeForeignCompanyNoReport',
  abroadIncomeFalseForeignCompanyReport: 'abroadIncomeFalseForeignCompanyReport',
  abroadIncomeFalseForeignCompanyNoReport: 'abroadIncomeFalseForeignCompanyNoReport',
  foreignRegionReport: 'foreignRegionReport',
  noFile_oleHadash: 'noFile_oleHadash',
  noReport_oleHadash: 'noReport_oleHadash',
  underReport_oleHadash: 'underReport_oleHadash',
  properReport_oleHadash: 'properReport_oleHadash',
  waitingForReport_oleHadash: 'waitingForReport_oleHadash',
  noFile_oldReturningResident: 'noFile_oleHadash',
  noReport_oldReturningResident: 'noReport_oleHadash',
  underReport_oldReturningResident: 'underReport_oleHadash',
  properReport_oldReturningResident: 'properReport_oleHadash',
  waitingForReport_oldReturningResident: 'waitingForReport_oleHadash',
  noFile_returningResident: 'noFile_oleHadash',
  noReport_returningResident: 'noReport_oleHadash',
  underReport_returningResident: 'underReport_oleHadash',
  properReport_returningResident: 'properReport_oleHadash',
  waitingForReport_returningResident: 'waitingForReport_oleHadash',
  noFile_disabled: 'noFile_oleHadash',
  noReport_disabled: 'noReport_oleHadash',
  underReport_disabled: 'underReport_oleHadash',
  properReport_disabled: 'properReport_oleHadash',
  waitingForReport_disabled: 'waitingForReport_oleHadash',
  noFile_oleHadash_disabled: 'noFile_oleHadash',
  noReport_oleHadash_disabled: 'noReport_oleHadash',
  underReport_oleHadash_disabled: 'underReport_oleHadash',
  properReport_oleHadash_disabled: 'properReport_oleHadash',
  waitingForReport_oleHadash_disabled: 'waitingForReport_oleHadash',
  noFile_oldReturningResident_disabled: 'noFile_oleHadash',
  noReport_oldReturningResident_disabled: 'noReport_oleHadash',
  underReport_oldReturningResident_disabled: 'underReport_oleHadash',
  properReport_oldReturningResident_disabled: 'properReport_oleHadash',
  waitingForReport_oldReturningResident_disabled: 'waitingForReport_oleHadash',
  noFile_returningResident_disabled: 'noFile_oleHadash',
  noReport_returningResident_disabled: 'noReport_oleHadash',
  underReport_returningResident_disabled: 'underReport_oleHadash',
  properReport_returningResident_disabled: 'properReport_oleHadash',
  waitingForReport_returningResident_disabled: 'waitingForReport_oleHadash'
}

interface ReportedStatusMap {
  statusIcon: string
  tooltipValue: string | null
}

export const reportedStatusMap: Record<string, ReportedStatusMap> = {
  processing: {
    statusIcon: statusIconMap.processing,
    tooltipValue: `The taxpayer's return has been filed but is still pending processing in the tax authority's database.`,
  },
  nonFilerRed: {
    statusIcon: statusIconMap.nonFilerRed,
    tooltipValue: null,
  },
  nonFilerOrange: {
    statusIcon: statusIconMap.nonFilerOrange,
    tooltipValue: null,
  },
  underReportedYellow: {
    statusIcon: statusIconMap.underReportedYellow,
    tooltipValue: null,
  },
  underReportedOrange: {
    statusIcon: statusIconMap.underReportedOrange,
    tooltipValue: null,
  },
  underReportedRed: {
    statusIcon: statusIconMap.underReportedRed,
    tooltipValue: null,
  },
  zeroReportedRed: {
    statusIcon: statusIconMap.zeroReportedRed,
    tooltipValue: null,
  },
  zeroReportedOrange: {
    statusIcon: statusIconMap.zeroReportedOrange,
    tooltipValue: null,
  },
  noFile: {
    statusIcon: statusIconMap.noFile,
    tooltipValue: 'No Record Found: This taxpayer currently does not have a file in the records.',
  },
  noReport: {
    statusIcon: statusIconMap.noReport,
    tooltipValue: 'Report Unfiled: Taxpayer has a file but has not submitted a tax report for this year.',
  },
  underReport: {
    statusIcon: statusIconMap.underReport,
    tooltipValue: `Income Underreported: Taxpayer's reported income is lower than our documented figures`,
  },
  noActivity: {
    statusIcon: statusIconMap.noActivity,
    tooltipValue: `No Documented Activity: No activity recorded for the taxpayer this year, no violations detected.`,
  },
  waitingForReport: {
    statusIcon: statusIconMap.waitingForReport,
    tooltipValue: `The taxpayer is within the deadline to file a tax return or is operating under an active extension period.`,
  },
  properReport: {
    statusIcon: statusIconMap.properReport,
    tooltipValue: `Accurate Report Filed: Taxpayer has accurately reported income matching our documented records.`,
  },
  abroadIncomeForeignCompanyReport: {
    statusIcon: statusIconMap.abroadIncomeForeignCompanyReport,
    tooltipValue: `The taxpayer Reported on Income from abroad and filed a Report on Holdings in a Foreign Company (FC).`,
  },
  abroadIncomeForeignCompanyNoReport: {
    statusIcon: statusIconMap.abroadIncomeForeignCompanyNoReport,
    tooltipValue: `The taxpayer Reported on Income from abroad and didn’t file a Report on Holdings in a Foreign Company (FC).`,
  },
  abroadIncomeFalseForeignCompanyReport: {
    statusIcon: statusIconMap.abroadIncomeFalseForeignCompanyReport,
    tooltipValue: `The taxpayer didn’t Report on Income from abroad and filed a Report on Holdings in a Foreign Company.`,
  },
  abroadIncomeFalseForeignCompanyNoReport: {
    statusIcon: statusIconMap.abroadIncomeFalseForeignCompanyNoReport,
    tooltipValue: `The taxpayer didn’t Report on Income from abroad and didn't filed a Report on Holdings in a Foreign Company.`,
  },
  foreignRegionReport: {
    statusIcon: statusIconMap.foreignRegionReport,
    tooltipValue: `The taxpayer has submitted a tax return within another jusrisdiction.`,
  },
  noFile_oleHadash: {
    statusIcon: statusIconMap.noFile_oleHadash,
    tooltipValue: 'No File, First-Time Resident',
  },
  noReport_oleHadash: {
    statusIcon: statusIconMap.noReport_oleHadash,
    tooltipValue: 'No Report, First-Time Resident',
  },
  underReport_oleHadash: {
    statusIcon: statusIconMap.underReport_oleHadash,
    tooltipValue: 'Under Report, First-Time Resident',
  },
  properReport_oleHadash: {
    statusIcon: statusIconMap.properReport_oleHadash,
    tooltipValue: 'True Report, First-Time Resident (New Immigrant)',
  },
  waitingForReport_oleHadash: {
    statusIcon: statusIconMap.waitingForReport_oleHadash,
    tooltipValue: 'Extension, First-Time Resident (New Immigrant)',
  },
  noFile_oldReturningResident: {
    statusIcon: statusIconMap.noFile_oldReturningResident,
    tooltipValue: 'No File, Veteran Returning Resident',
  },
  noReport_oldReturningResident: {
    statusIcon: statusIconMap.noReport_oldReturningResident,
    tooltipValue: 'No Report, Veteran Returning Resident',
  },
  underReport_oldReturningResident: {
    statusIcon: statusIconMap.underReport_oldReturningResident,
    tooltipValue: 'Under Report, Veteran Returning Resident',
  },
  properReport_oldReturningResident: {
    statusIcon: statusIconMap.properReport_oldReturningResident,
    tooltipValue: 'True Report, Veteran Returning Resident',
  },
  waitingForReport_oldReturningResident: {
    statusIcon: statusIconMap.waitingForReport_oldReturningResident,
    tooltipValue: 'Extension, Veteran Returning Resident',
  },
  noFile_returningResident: {
    statusIcon: statusIconMap.noFile_returningResident,
    tooltipValue: 'No File, Returning Resident',
  },
  noReport_returningResident: {
    statusIcon: statusIconMap.noReport_returningResident,
    tooltipValue: 'No Report, Returning Resident',
  },
  underReport_returningResident: {
    statusIcon: statusIconMap.underReport_returningResident,
    tooltipValue: 'Under Report, Returning Resident',
  },
  properReport_returningResident: {
    statusIcon: statusIconMap.properReport_returningResident,
    tooltipValue: 'True Report, Returning Resident',
  },
  waitingForReport_returningResident: {
    statusIcon: statusIconMap.waitingForReport_returningResident,
    tooltipValue: 'Extension, Returning Resident',
  },
  noFile_disabled: {
    statusIcon: statusIconMap.noFile_disabled,
    tooltipValue: 'No File, Exempt Disabled Individual',
  },
  noReport_disabled: {
    statusIcon: statusIconMap.noReport_disabled,
    tooltipValue: 'No Report, Exempt Disabled Individual',
  },
  underReport_disabled: {
    statusIcon: statusIconMap.underReport_disabled,
    tooltipValue: 'Under Report, Exempt Disabled Individual',
  },
  properReport_disabled: {
    statusIcon: statusIconMap.properReport_disabled,
    tooltipValue: 'True Report, Exempt Disabled Individual',
  },
  waitingForReport_disabled: {
    statusIcon: statusIconMap.waitingForReport_disabled,
    tooltipValue: 'Extension, Exempt Disabled Individual',
  },
  noFile_oleHadash_disabled: {
    statusIcon: statusIconMap.noFile_oleHadash_disabled,
    tooltipValue: 'No File, First-Time Resident, Exempt Disabled Individual',
  },
  noReport_oleHadash_disabled: {
    statusIcon: statusIconMap.noReport_oleHadash_disabled,
    tooltipValue: 'No Report, First-Time Resident, Exempt Disabled Individual',
  },
  underReport_oleHadash_disabled: {
    statusIcon: statusIconMap.underReport_oleHadash_disabled,
    tooltipValue: 'Under Report, First-Time Resident, Exempt Disabled Individual',
  },
  properReport_oleHadash_disabled: {
    statusIcon: statusIconMap.properReport_oleHadash_disabled,
    tooltipValue: 'True Report, First-Time Resident (New Immigrant), Exempt Disabled Individual',
  },
  waitingForReport_oleHadash_disabled: {
    statusIcon: statusIconMap.waitingForReport_oleHadash_disabled,
    tooltipValue: 'Extension, First-Time Resident (New Immigrant), Exempt Disabled Individual',
  },
  noFile_oldReturningResident_disabled: {
    statusIcon: statusIconMap.noFile_oldReturningResident_disabled,
    tooltipValue: 'No File, Veteran Returning Resident, Exempt Disabled Individual',
  },
  noReport_oldReturningResident_disabled: {
    statusIcon: statusIconMap.noReport_oldReturningResident_disabled,
    tooltipValue: 'No Report, Veteran Returning Resident, Exempt Disabled Individual',
  },
  underReport_oldReturningResident_disabled: {
    statusIcon: statusIconMap.underReport_oldReturningResident_disabled,
    tooltipValue: 'Under Report, Veteran Returning Resident, Exempt Disabled Individual',
  },
  properReport_oldReturningResident_disabled: {
    statusIcon: statusIconMap.properReport_oldReturningResident_disabled,
    tooltipValue: 'True Report, Veteran Returning Resident, Exempt Disabled Individual',
  },
  waitingForReport_oldReturningResident_disabled: {
    statusIcon: statusIconMap.waitingForReport_oldReturningResident_disabled,
    tooltipValue: 'Extension, Veteran Returning Resident, Exempt Disabled Individual',
  },
  noFile_returningResident_disabled: {
    statusIcon: statusIconMap.noFile_returningResident_disabled,
    tooltipValue: 'No File, Returning Resident, Exempt Disabled Individual',
  },
  noReport_returningResident_disabled: {
    statusIcon: statusIconMap.noReport_returningResident_disabled,
    tooltipValue: 'No Report, Returning Resident, Exempt Disabled Individual',
  },
  underReport_returningResident_disabled: {
    statusIcon: statusIconMap.underReport_returningResident_disabled,
    tooltipValue: 'Under Report, Returning Resident, Exempt Disabled Individual',
  },
  properReport_returningResident_disabled: {
    statusIcon: statusIconMap.properReport_returningResident_disabled,
    tooltipValue: 'True Report, Returning Resident, Exempt Disabled Individual',
  },
  waitingForReport_returningResident_disabled: {
    statusIcon: statusIconMap.waitingForReport_returningResident_disabled,
    tooltipValue: 'Extension, Returning Resident, Exempt Disabled Individual',
  }
}

export type ReportedStatusType = Record<string, reportedStatusValue>

interface ReportedStatusProps {
  id: string
  reportedStatus: ReportedStatusType
}

const ReportedStatus: React.FC<ReportedStatusProps> = ({ reportedStatus, id }: ReportedStatusProps) => (
  <div className={styles.reportedStatus}>
    {Object.entries(reportedStatus || {})
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .sort(([aKey, _1], [bKey, _2]) => parseInt(aKey) - parseInt(bKey))
      .map(([year, status]) => {
        const statusIcon = reportedStatusMap?.[status as reportedStatusValue]?.statusIcon
        const tooltipValue = reportedStatusMap?.[status as reportedStatusValue]?.tooltipValue || ''
        return (
          <Tooltip key={`${year}-${id}`} title={tooltipValue}>
            <div className={styles.inner}>
              <span className={styles.title}>{year}</span>
              <Icon name={statusIcon} size='regular' className={cx(styles.value)} />
            </div>
          </Tooltip>
        )
      })}
  </div>
)

export default ReportedStatus
